var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_2130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82486 10.675C3.42141 8.51087 2.54516 6.04768 2.26653 3.48337C2.2457 3.25293 2.27309 3.02067 2.34695 2.80139C2.4208 2.58211 2.53951 2.38061 2.6955 2.20972C2.8515 2.03883 3.04137 1.9023 3.25302 1.80881C3.46468 1.71532 3.69348 1.66692 3.92486 1.66671H6.42486C6.82928 1.66273 7.22136 1.80594 7.528 2.06965C7.83464 2.33336 8.03493 2.69958 8.09153 3.10004C8.19705 3.9001 8.39274 4.68565 8.67486 5.44171C8.78698 5.73998 8.81125 6.06414 8.74478 6.37577C8.67832 6.68741 8.52392 6.97347 8.29986 7.20004L7.24153 8.25837M9.39986 11.0917C10.2456 11.9382 11.2014 12.6669 12.2415 13.2584L13.2999 12.2C13.5264 11.976 13.8125 11.8216 14.1241 11.7551C14.4358 11.6887 14.7599 11.7129 15.0582 11.825C15.8143 12.1072 16.5998 12.3029 17.3999 12.4084C17.8003 12.465 18.1665 12.6653 18.4303 12.9719C18.694 13.2785 18.8372 13.6706 18.8332 14.075V16.575C18.8341 16.8071 18.7866 17.0368 18.6936 17.2495C18.6006 17.4621 18.4643 17.653 18.2933 17.8099C18.1222 17.9668 17.9203 18.0863 17.7005 18.1606C17.4806 18.235 17.2477 18.2626 17.0165 18.2417C14.4522 17.9631 11.989 17.0868 9.82486 15.6834C8.82092 15.0459 7.8903 14.2997 7.04986 13.4584L9.39986 11.0917Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6663 0.833374L1.33301 19.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_2130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOff);
export default __webpack_public_path__ + "static/media/phone-off.40cf1788c4cb6dcc9d5afc7f6544b3a3.svg";
export { ForwardRef as ReactComponent };